import React from "react";
import { useLocalization } from "@fluent/react";
import { ContextForm, TaxIDTextInput, validateTaxID } from "cerulean";
import useRevalidateErroringField from "../hooks/useRevalidateErroringField";

type TaxIdFieldProps = {
  required?: boolean;
  revalidateErrorsOnBlur?: boolean;
};

const TaxIdField = ({
  required = true,
  revalidateErrorsOnBlur = false
}: TaxIdFieldProps) => {
  const { l10n } = useLocalization();
  const field = "tin";
  const revalidateErroringField = useRevalidateErroringField(field);

  return (
    <ContextForm.Field required={required} validate={validateTaxID} key={field}>
      <TaxIDTextInput
        field={field}
        label={l10n.getString("label-ssn", null, "Social security number")}
        onBlur={revalidateErrorsOnBlur ? revalidateErroringField : undefined}
      />
    </ContextForm.Field>
  );
};

export default TaxIdField;
